import { FC, useEffect } from 'react'
import Script from 'next/script'
import { hotjar } from 'react-hotjar'
import { useConsentStore } from 'store/consentStore'
import { hotjarSnippet, metaPixelSnippet } from '@/lib/trackingSnippets'
import { HJID, HJSV } from '@/configs'
import { PartnerPageData } from 'types/types'

interface ConsentGatedScriptsProps {
  page: PartnerPageData
}

// TBL's non-essential scripts, loaded only once the visitor has consented to them. Google is
// gated separately by Consent Mode.
export const ConsentGatedScripts: FC<ConsentGatedScriptsProps> = ({ page }) => {
  const consent = useConsentStore((state) => state.consent)
  const init = useConsentStore((state) => state.init)

  useEffect(() => {
    init()
  }, [init])

  // One Hotjar per page: two would overwrite each other's settings. The partner's own site id
  // when it has one, otherwise the site-wide one.
  const hasPartnerHotjar = Boolean(page.hotjar_id && page.hotjar_sv)
  useEffect(() => {
    if (consent?.analytics && hasPartnerHotjar)
      hotjar.initialize(Number(page.hotjar_id), Number(page.hotjar_sv))
  }, [consent?.analytics, hasPartnerHotjar, page.hotjar_id, page.hotjar_sv])

  return (
    <>
      {consent?.marketing && page.meta_pixel_id && (
        <Script
          id="facebook-pixel"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: metaPixelSnippet(page.meta_pixel_id) }}
        />
      )}
      {consent?.analytics && !hasPartnerHotjar && HJID && HJSV && (
        <Script
          id="hotjar"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{ __html: hotjarSnippet(HJID, HJSV) }}
        />
      )}
    </>
  )
}
